export default {"src":"/_next/static/media/close_blue.00573cf8.svg","height":16,"width":16};